
const nameList = [
    {
        entityField: "fileNumber",
        showField: "档案编号",
        fieldWeight: 110,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "bgmCode",
        showField: "商品编号",
        fieldWeight: 130,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "bgmName",
        showField: "通用名称",
        fieldWeight: 130,
        fieldType: "string",
        isRift: 1,
        riftField: "bgmId",
        fixed:'left',
    },
    {
        entityField: "bgiGename",
        showField: "商品名称",
        fieldWeight: 130,
        fieldType: "string",
        isRift: 1,
        riftField: "bgmId",
        fixed:'left',
    },
    {
        entityField: "goodReserves4",
        showField: "装量",
        fieldWeight: 90,
        fieldType: "string",
        isRift: 1,
        riftField: "bgmId",
        fixed:'left',
    },
    {
        entityField: "bgiBrand",
        showField: "品牌",
        fieldWeight: 90,
        fieldType: "string",
        isRift: 1,
        riftField: "bgmId",
        fixed:'left',
    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 110,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "manufacturer",
        showField: "生产厂商",
        fieldWeight: 180,
        fieldType: "string",
        fixed:'left',
    }, {
        entityField: "placeorigin",
        showField: "产地",
        fieldWeight: 60,
        fieldType: "string",
        fixed:'left',
    }, {
        entityField: "bgpUnitmeasurement",
        showField: "包装单位",
        fieldWeight: 70,
        fieldType: "string",
        fixed:'left',
    }, {
        entityField: "packingSpec",
        showField: "装箱规格",
        fieldWeight: 70,
        fieldType: "string",
        fixed:'left',
    },
      {
        entityField:"stockNum",
        showField:"库存数量",
        fieldWeight:110,
        fieldType:"string"
      },
    {
        entityField: "lastPirce",
        showField: "最后进价",
        fieldWeight:70,
        fieldType: "string",
        fixed:'left',
    },

]
export default nameList
